export default function filterLiveMachines(machines, search) {
  const query = search.trim().toLocaleLowerCase();
  return machines.filter(machine => (
    String(machine.name || '').toLocaleLowerCase().includes(query)
    || String(machine.id || '').toLocaleLowerCase().includes(query)
  ));
}
